import { render, staticRenderFns } from "./updateOperatorSetting2.vue?vue&type=template&id=dbd77b60&lang=pug"
import script from "./updateOperatorSetting2.vue?vue&type=script&lang=js"
export * from "./updateOperatorSetting2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports